import React from 'react'
import { RowButton } from 'components/atoms'
import { productTableColumns } from 'domains/product'

const productCollectionDeleteItemTableColumns = ({ handleClickDeleteItem }) => {
  // eslint-disable-next-line react/prop-types
  const ActionCell = ({ cell: { row } }) => (
    <RowButton
      // eslint-disable-next-line react/prop-types
      data={ row.original }
      className='w-100'
      color="danger"
      onClick={ handleClickDeleteItem }
      text="Delete"
    />
  )

  return (
    [
      ...productTableColumns(),
      {
        Header : 'Action',
        id     : 'action',
        Cell   : ActionCell
      }
    ]
  )
}

export default productCollectionDeleteItemTableColumns
